import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { Text, Skeleton, Alert } from "@grandvisionhq/iris-ui";
import { ShippingMethodPlaceholder } from "../../../components/StepShipping/components/AlternativeShippingMethodsList/components/ShippingMethodPlaceholder.js";
import { useGroupedShippingMethods } from "../../../hooks/StepShipping/components/AlternativeShippingMethodsList/hooks/use-grouped-shipping-methods.js";
/* empty css                                    */
import { ShippingMethod } from "../../../../../../models/step-shipping/models/step-shipping/shipping-methods.js";
import { ShippingMethodsList } from "../../../../../modules/ShippingMethods/components/StepShipping/modules/ShippingMethods/components/ShippingMethodsList.js";
const AlternativeShippingMethodsList = ({
  labels,
  onSubmit,
  onChange,
  onModalClose,
  selectedShippingMethod
}) => {
  const homeDeliveryShippingMethodGroups = React.useMemo(() => {
    const sharedGroup = [
      ShippingMethod.Delivery,
      ShippingMethod.DeliveryExpress,
      ShippingMethod.DeliveryPremium
    ];
    return Object.fromEntries(sharedGroup.map((method) => [method, sharedGroup]));
  }, []);
  const allowedKeys = React.useMemo(() => {
    return selectedShippingMethod?.method ? homeDeliveryShippingMethodGroups[selectedShippingMethod.method] || [
      selectedShippingMethod.method
    ] : [];
  }, [selectedShippingMethod?.method, homeDeliveryShippingMethodGroups]);
  const handleCompleted = React.useCallback(
    (shippingMethods) => {
      const filteredShippingMethods = shippingMethods.filter(
        (item) => allowedKeys.includes(item.key)
      );
      if (filteredShippingMethods.length === 0) {
        onSubmit();
      }
    },
    [allowedKeys, onSubmit]
  );
  const { groupedShippingMethods, error, isLoading } = useGroupedShippingMethods(
    allowedKeys,
    handleCompleted
  );
  const shippingMethodsList = React.useMemo(
    () => groupedShippingMethods.filter((item) => allowedKeys.includes(item.value)),
    [allowedKeys, groupedShippingMethods]
  );
  const hasValidationError = !selectedShippingMethod?.isValid && selectedShippingMethod?.isTouched;
  const handleChange = (shippingMethodKey) => {
    const shippingMethod = groupedShippingMethods.find((item) => item.value === shippingMethodKey);
    onChange(shippingMethod);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "alternative-shipping-methods" }, isLoading && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, { color: "text-secondary" }, labels.description), /* @__PURE__ */ React.createElement(ShippingMethodPlaceholder, null), /* @__PURE__ */ React.createElement(ShippingMethodPlaceholder, null), /* @__PURE__ */ React.createElement(ShippingMethodPlaceholder, null), /* @__PURE__ */ React.createElement("div", { className: "alternative-shipping-methods__button-placeholder" }, /* @__PURE__ */ React.createElement(Skeleton, { height: 48, width: "100%", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React.createElement("rect", { width: "100%", rx: "4", height: "48px", fill: "currentColor" })))), error && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Alert, { variant: "error", title: labels.errorTitle }, labels.errorDescription), /* @__PURE__ */ React.createElement(Button, { variant: "outline", caption: labels.back, onClick: onModalClose })), !isLoading && shippingMethodsList?.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, null, labels.description), /* @__PURE__ */ React.createElement(
    ShippingMethodsList,
    {
      handleChange,
      shippingMethodItems: shippingMethodsList,
      selectedShippingMethod: selectedShippingMethod?.method ? selectedShippingMethod?.method : "",
      hasValidationError
    }
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      style: { width: "100%" },
      caption: labels.buttonCaptionLabel,
      onClick: onSubmit
    }
  )));
};
export {
  AlternativeShippingMethodsList
};
//# sourceMappingURL=AlternativeShippingMethodsList.js.map
